import * as React from 'react';

const SvgActionEmailFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M2 8.58V20h20V8.58l-10 5.77L2 8.58ZM2 4v2.27L12 12l10-5.73V4H2Z" })
);

export { SvgActionEmailFill as default };
//# sourceMappingURL=ActionEmailFill.es.js.map
